import {installChatPublicBrowser} from './runtime/chatPublicBrowser.gen';

export function createLandingAnalytics(configs: unknown): () => void {
  let installed: ReturnType<typeof installChatPublicBrowser> | undefined;
  return () => {
    try {
      installed ??= installChatPublicBrowser(`landing`, configs);
      installed.update();
    } catch {
      // Gatsby page rendering and Open Chat links remain independent.
    }
  };
}
